export default class DeviceDisconnectedError extends Error {
    constructor() {
        super('Device is disconnected');
    }
}
